import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';

import {
  deleteSavedMonitoringPortfolio,
  getSavedCreditSafeCompanies,
  getSavedMonitoringPortfolios,
  updateSavedMonitoringPortfolio,
} from '../services/creditReportService';
import { CreditSafePortfolioInitialState } from '../globalSlices/creditSafeSlice';
import { CreditSafePortfolio } from '@dill/dill-shared/dist/src';

export const getSavedMonitoringPortfoliosExtraReducer = (
  builder: ActionReducerMapBuilder<CreditSafePortfolioInitialState>
) => {
  const reducerId = 'getSavedMonitoringPortfolios';
  builder.addCase(getSavedMonitoringPortfolios.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSavedMonitoringPortfolios.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.creditMonitoringPortfolios = action.payload?.data;
      }
    }
  );
  builder.addCase(getSavedMonitoringPortfolios.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const updateSavedMonitoringPortfolioExtraReducer = (
  builder: ActionReducerMapBuilder<CreditSafePortfolioInitialState>
) => {
  const reducerId = 'updateSavedMonitoringPortfolio';
  builder.addCase(updateSavedMonitoringPortfolio.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    updateSavedMonitoringPortfolio.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        const data = action.payload.data as CreditSafePortfolio;
        state.creditMonitoringPortfolios = state.creditMonitoringPortfolios.map((item) =>
          item.id === data.id ? data : item
        );
      }
    }
  );
  builder.addCase(updateSavedMonitoringPortfolio.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const deleteSavedMonitoringPortfolioExtraReducer = (
  builder: ActionReducerMapBuilder<CreditSafePortfolioInitialState>
) => {
  const reducerId = 'deleteSavedMonitoringPortfolio';
  builder.addCase(deleteSavedMonitoringPortfolio.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    deleteSavedMonitoringPortfolio.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(deleteSavedMonitoringPortfolio.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getSavedCreditSafeCompaniesExtraReducer = (
  builder: ActionReducerMapBuilder<CreditSafePortfolioInitialState>
) => {
  const reducerId = 'getSavedCreditSafeCompanies';
  builder.addCase(getSavedCreditSafeCompanies.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSavedCreditSafeCompanies.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.creditSafeCompanies = action.payload?.data;
      }
    }
  );
  builder.addCase(getSavedCreditSafeCompanies.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
